export var TRK_PRODUCT_LOCATION = 'ExpandableContent';
export var RECOMPUTE_DELAY = 250; // ms

export var ENTER_KEY = 13;
/**
 * Keep in sync with definition in `./expandable-content.module.less`
 */

export var COLLAPSED_HEIGHT_OPTIONS = {
  DRIVER_TITLE_HEIGHT: 'DRIVER_TITLE_HEIGHT',
  FOUR_LINES_HEIGHT: 'FOUR_LINES_HEIGHT'
};
/**
 * Text alignment constants.
 */

export var ALIGNMENTS = {
  LEFT: 'left',
  CENTER: 'center'
};
/**
 * Analytics entity name
 */

export var MORE_DETAILS = 'expandable_content';